<template>
  <link
    rel="stylesheet"
    href="https://fonts.googleapis.com/icon?family=Material+Icons"
  />
  <link
    href="https://stackpath.bootstrapcdn.com/bootstrap/4.5.0/css/bootstrap.min.css"
    rel="stylesheet"
  />
  <link
    rel="stylesheet"
    href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@24,400,0,0"
  />
  <!--Main Navigation-->
  <header>
    <!-- Navbar Component -->
    <Navbar
      :usuario="usuario"
      :perfil="rol"
      :modulo="Number(modulo)"
      @logout="handleLogout"
    />

    <!-- Sidebar -->
    <nav id="sidebarMenu" class="d-lg-block sidebar collapse bg-white">
      <div class="accordion" id="accordionExample">
        <div class="accordion-item" v-if="true">
          <div class="inicio" @click="menu_principal()">
            <i class="material-icons">home</i>&nbsp;&nbsp;Inicio
          </div>
        </div>
        <!--
Módulo: Administracion De Usuarios
-->
        <div v-if="modulo == 1">
          <div class="accordion-item">
            <h2 class="accordion-header" id="headingOne">
              <button
                class="accordion-button"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseOne"
                aria-expanded="true"
                aria-controls="collapseOne"
                :disabled="menuProcesos === 0"
                @click="menuProcesos !== 0 && toggleProcesos"
              >
                <i class="material-icons">settings</i>
                &nbsp;&nbsp;Procesos
              </button>
            </h2>
            <div
              id="collapseOne"
              class="accordion-collapse collapse"
              :class="{ show: selectedOption === 1 && procesosMenuOpen }"
              aria-labelledby="headingOne"
              data-bs-parent="#accordionExample"
            >
              <ul
                id="collapseExample1"
                class="show list-group list-group-flush"
                style="height: 500px; overflow: auto"
              >
                <li class="list-group-item py-1">
                  <div
                    v-for="(route, index) in adminProcesosRoutes"
                    :key="'admin-procesos-' + index"
                  >
                    <router-link class="nav-link" :to="route.path">{{
                      route.name
                    }}</router-link>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="accordion-item">
            <h2 class="accordion-header" id="headingTwo">
              <button
                class="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseTwo"
                aria-expanded="false"
                aria-controls="collapseTwo"
                :disabled="menuReportes === 0"
                @click="menuReportes !== 0 && toggleReportes"
              >
                <i class="material-icons">leaderboard</i>
                &nbsp;&nbsp;Reportes
              </button>
            </h2>
            <div
              id="collapseTwo"
              class="accordion-collapse collapse"
              :class="{ show: selectedOption === 2 && reportesMenuOpen }"
              aria-labelledby="headingTwo"
              data-bs-parent="#accordionExample"
            >
              <ul
                id="collapseExample1"
                class="show list-group list-group-flush"
                style="height: 500px; overflow: auto"
              >
                <li class="list-group-item py-1">
                  <div
                    v-for="(route, index) in adminReportesRoutes"
                    :key="'admin-reportes-' + index"
                  >
                    <router-link class="nav-link" :to="route.path">{{
                      route.name
                    }}</router-link>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="accordion-item">
            <h2 class="accordion-header" id="headingThree">
              <button
                class="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseThree"
                aria-expanded="false"
                aria-controls="collapseThree"
                :disabled="menuParametros === 0"
                @click="menuParametros !== 0 && toggleParametros"
              >
                <i class="material-icons">grid_view</i>
                &nbsp;&nbsp;Parámetros
              </button>
            </h2>
            <div
              id="collapseThree"
              class="accordion-collapse collapse"
              :class="{ show: selectedOption === 3 && parametrosMenuOpen }"
              aria-labelledby="headingThree"
              data-bs-parent="#accordionExample"
            >
              <ul
                id="collapseExample1"
                class="show list-group list-group-flush"
                style="height: 500px; overflow: auto"
              >
                <li class="list-group-item py-1">
                  <div
                    v-for="(route, index) in adminParametrosRoutes"
                    :key="'admin-parametros-' + index"
                  >
                    <router-link class="nav-link" :to="route.path">{{
                      route.name
                    }}</router-link>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!--
Módulo: AlliKamay
-->
        <div v-if="modulo == 5">
          <div class="accordion-item">
            <h2 class="accordion-header" id="headingOne">
              <button
                class="accordion-button"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseOne"
                aria-expanded="true"
                aria-controls="collapseOne"
                v-if="menuProcesos === 1"
                @click="menuProcesos !== 0 && toggleProcesos"
              >
                <i class="material-icons">settings</i>
                &nbsp;&nbsp;Procesos
              </button>
            </h2>
            <div
              id="collapseOne"
              class="accordion-collapse collapse"
              :class="{ show: selectedOption === 1 && procesosMenuOpen }"
              aria-labelledby="headingOne"
              data-bs-parent="#accordionExample"
            >
              <ul
                class="show list-group list-group-flush"
                style="height: 500px; overflow: auto"
              >
                <li class="list-group-item py-1">
                  <div
                    v-for="(route, index) in acfssProcesosRoutes"
                    :key="'acfss-procesos-' + index"
                  >
                    <div
                      v-if="route.dividerTitle"
                      class="text-primary text-uppercase small my-2 ps-0"
                      style="font-weight: 600"
                    >
                      {{ route.dividerTitle }}
                    </div>

                    <hr v-else-if="route.divider" class="my-2" />

                    <router-link v-else class="nav-link px-2" :to="route.path">
                      {{ route.meta?.title || route.name }}
                    </router-link>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="accordion-item">
            <h2 class="accordion-header" id="headingTwo">
              <button
                class="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseTwo"
                aria-expanded="false"
                aria-controls="collapseTwo"
                v-if="menuReportes === 1"
                @click="menuReportes !== 0 && toggleReportes"
              >
                <i class="material-icons">leaderboard</i>
                &nbsp;&nbsp;Reportes
              </button>
            </h2>
            <div
              id="collapseTwo"
              class="accordion-collapse collapse"
              :class="{ show: selectedOption === 2 && reportesMenuOpen }"
              aria-labelledby="headingTwo"
              data-bs-parent="#accordionExample"
            >
              <ul
                class="show list-group list-group-flush"
                style="height: 500px; overflow: auto"
              >
                <li class="list-group-item py-1">
                  <div
                    v-for="(route, index) in acfssReportesRoutes"
                    :key="'acfss-reportes-' + index"
                  >
                    <div
                      v-if="route.dividerTitle"
                      class="text-primary text-uppercase small my-2"
                      style="font-weight: 600; padding-left: 0"
                    >
                      {{ route.dividerTitle }}
                    </div>
                    <hr v-else-if="route.divider" class="my-2" />
                    <router-link v-else class="nav-link px-2" :to="route.path">
                      {{ route.meta?.title || route.name }}
                    </router-link>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="accordion-item">
            <h2 class="accordion-header" id="headingThree">
              <button
                class="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseThree"
                aria-expanded="false"
                aria-controls="collapseThree"
                v-if="menuParametros === 1"
                @click="menuParametros !== 0 && toggleParametros"
              >
                <i class="material-icons">grid_view</i>
                &nbsp;&nbsp;Parámetros
              </button>
            </h2>
            <div
              id="collapseThree"
              class="accordion-collapse collapse"
              :class="{ show: selectedOption === 3 && parametrosMenuOpen }"
              aria-labelledby="headingThree"
              data-bs-parent="#accordionExample"
            >
              <ul
                class="show list-group list-group-flush"
                style="height: 500px; overflow: auto"
              >
                <li class="list-group-item py-1">
                  <div
                    v-for="(route, index) in acfssParametrosRoutes"
                    :key="'acfss-parametros-' + index"
                  >
                    <div
                      v-if="route.dividerTitle"
                      class="text-primary text-uppercase small my-2 ps-0"
                      style="font-weight: 600"
                    >
                      {{ route.dividerTitle }}
                    </div>
                    <hr v-else-if="route.divider" class="my-2" />
                    <router-link v-else class="nav-link px-2" :to="route.path">
                      {{ route.meta?.title || route.name }}
                    </router-link>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!--
Ayuda
-->
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingFour">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseFour"
              aria-expanded="false"
              aria-controls="collapseFour"
              v-if="menuAyuda === 1"
              @click="menuAyuda !== 0 && toggleAyuda"
            >
              <i class="material-icons">help_outline</i>
              &nbsp;&nbsp;Ayuda
            </button>
          </h2>
          <div
            id="collapseFour"
            class="accordion-collapse collapse"
            :class="{ show: selectedOption === 4 && ayudaMenuOpen }"
            aria-labelledby="headingFour"
            data-bs-parent="#accordionExample"
          >
            <ul
              class="show list-group list-group-flush"
              style="height: 500px; overflow: auto"
            >
              <li class="list-group-item py-1">
                <div
                  v-for="(route, index) in acfssAyudaRoutes"
                  :key="'acfss-parametros-' + index"
                >
                  <div
                    v-if="route.dividerTitle"
                    class="text-primary text-uppercase small my-2 ps-0"
                    style="font-weight: 600"
                  >
                    {{ route.dividerTitle }}
                  </div>
                  <hr v-else-if="route.divider" class="my-2" />
                  <router-link v-else class="nav-link px-2" :to="route.path">
                    {{ route.meta?.title || route.name }}
                  </router-link>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </nav>
    <!-- Sidebar -->
  </header>
  <!--Main Navigation-->

  <!--Main layout-->
  <main style="margin-top: 20px">
    <div class="container pt-4"></div>
  </main>
  <!--Main layout-->
</template>
<script>
//import jwt_decode from 'jwt-decode';
//import { jwtDecode } from "jwt-decode";
import * as jwtDecode from "jwt-decode";

import Navbar from "@/components/Navbar.vue";
import inactividadMixin from "@/mixins/inactividadMixin";

import { routes as adminProcesosRoutes } from "@/router/mod/AdminProcesos.js";
import { routes as adminReportesRoutes } from "@/router/mod/AdminReportes.js";
import { routes as adminParametrosRoutes } from "@/router/mod/AdminParametros.js";
import { routes as acfssProcesosRoutes } from "@/router/mod/AcfssProcesos.js";
import { routes as acfssReportesRoutes } from "@/router/mod/AcfssReportes.js";
import { routes as acfssParametrosRoutes } from "@/router/mod/AcfssParametros.js";
import { routes as acfssAyudaRoutes } from "@/router/mod/AcfssAyuda.js";
export default {
  mixins: [inactividadMixin],
  props: {
    selectedOption: Number,
  },
  components: {
    Navbar,
  },
  data() {
    return {
      token: "",
      rol: "",
      usuario: "",
      nombreEmpresa: "",
      idEmpresa: 0,
      modulo: 1,
      procesos: false,
      parametros: false,
      administracion: false,
      reportes: false,
      ayuda: false,
      menuParametros: 0,
      menuProcesos: 0,
      menuReportes: 0,
      menuAyuda: 0,
      procesosMenuOpen: false,
      reportesMenuOpen: false,
      parametrosMenuOpen: false,
      ayudaMenuOpen: false,
      adminProcesosRoutes,
      adminReportesRoutes,
      adminParametrosRoutes,
      acfssProcesosRoutes,
      acfssReportesRoutes,
      acfssParametrosRoutes,
      acfssAyudaRoutes,
    };
  },
  mounted() {
    this.valorToken();
    this.authorization();
    this.initializeMenuSettings();
  },
  methods: {
    toggleProcesos() {
      if (this.selectedOption === 1) {
        this.procesosMenuOpen = !this.procesosMenuOpen;
        if (this.procesosMenuOpen) {
          this.reportesMenuOpen = false;
          this.parametrosMenuOpen = false;
          this.ayudaMenuOpen = false;
        }
      }
    },
    toggleReportes() {
      if (this.selectedOption === 2) {
        this.reportesMenuOpen = !this.reportesMenuOpen;
        if (this.reportesMenuOpen) {
          this.procesosMenuOpen = false;
          this.parametrosMenuOpen = false;
          this.ayudaMenuOpen = false;
        }
      }
    },
    toggleParametros() {
      if (this.selectedOption === 3) {
        this.parametrosMenuOpen = !this.parametrosMenuOpen;
        if (this.parametrosMenuOpen) {
          this.procesosMenuOpen = false;
          this.reportesMenuOpen = false;
          this.ayudaMenuOpen = false;
        }
      }
    },
    toggleAyuda() {
      if (this.selectedOption === 4) {
        this.ayudaMenuOpen = !this.ayudaMenuOpen;
        if (this.ayudaMenuOpen) {
          this.procesosMenuOpen = false;
          this.reportesMenuOpen = false;
          this.parametrosMenuOpen = false;
        }
      }
    },
    async menu_principal() {
      window.sessionStorage.setItem("modulo", "0");
      this.$router.replace({ path: "/empty" }).then(() => {
        this.$router.replace("/MenuPrincipal");
      });
    },
    async authorization() {
      this.token = window.sessionStorage.getItem("token");
      this.rol = window.sessionStorage.getItem("rol");
      this.usuario = window.sessionStorage.getItem("usuario");
      this.idEmpresa = window.sessionStorage.getItem("idEmpresa");
      this.nombreEmpresa = window.sessionStorage.getItem("nombreEmpresa");
      this.modulo = window.sessionStorage.getItem("modulo");
      //                  alert('navbar: ' + this.modulo);
      if (this.rol == "ADMINISTRADOR") {
        this.procesos = true;
        this.parametros = true;
        this.administracion = true;
        this.reportes = true;
        this.ayuda = true;
      }
    },
    handleLogout(action) {
      if (action === "logout") {
        this.logout();
        this.$router.push("/");
      } else if (action === "changeUser") {
        this.logout();
        this.$router.push("/Login");
      }
    },
    logout() {
      window.sessionStorage.removeItem("idPerfil");
      window.sessionStorage.removeItem("idUsuario");
      window.sessionStorage.removeItem("usuario");
      window.sessionStorage.removeItem("token");
      window.sessionStorage.removeItem("rol");
      window.sessionStorage.removeItem("idEmpresa");
      window.sessionStorage.removeItem("nombreEmpresa");
    },
    async valorToken() {
      const token = window.sessionStorage.getItem("token");
      //                  if (!token || jwtDecode(token).exp * 1000 < Date.now()) {
      if (!token || jwtDecode.default(token).exp * 1000 < Date.now()) {
        this.$router.push("/Login");
      }
    },
    initializeMenuSettings() {
      this.menuParametros =
        parseInt(window.sessionStorage.getItem("menuParametros"), 10) || 0;
      this.menuProcesos =
        parseInt(window.sessionStorage.getItem("menuProcesos"), 10) || 0;
      this.menuReportes =
        parseInt(window.sessionStorage.getItem("menuReportes"), 10) || 0;
      this.menuAyuda =
        parseInt(window.sessionStorage.getItem("menuAyuda"), 10) || 0;
    },
  },
};
</script>
<style src="@/assets/css/menu_azul.css" scoped></style>
<!-- <style src="@/assets/css/breadcrumbs.css"></style> -->
<!-- <style scoped>
.icono-tamano {
      font-size: 48px;
}

.offcanvas-body {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 100%;
}

.separador-con-texto {
      display: block;
      text-align: center;
      font-weight: bold;
      color: #007bff;
      margin: 10px 0;
}
</style> -->
